// Kort relativ alder for ferskhets-chips («i går», «for 3 dager siden»).
// Bruker Intl.RelativeTimeFormat slik at alle app-språk støttes uten egne nøkler.
export function formatRelativeAge(ts: number, locale: string): string {
  const diffMs = Math.max(0, Date.now() - ts);
  const rtf = new Intl.RelativeTimeFormat(locale || 'no', { numeric: 'auto' });

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return rtf.format(-minutes, 'minute');

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return rtf.format(-hours, 'hour');

  const days = Math.floor(hours / 24);
  if (days < 7) return rtf.format(-days, 'day');

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return rtf.format(-weeks, 'week');

  return rtf.format(-Math.floor(days / 30), 'month');
}
